/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import { collaboratorFragment } from '../../apollo/fragments/collaboratorFragment.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetApplicationEmails_creditApplication_CreditApplication_collaborators_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly createAsAdmin: boolean | null, readonly lastLoginAt: any | null };

export type GetApplicationEmails_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly createAsAdmin: boolean | null, readonly lastLoginAt: any | null };

export type GetApplicationEmails_creditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly createAsAdmin: boolean | null, readonly lastLoginAt: any | null };

export type GetApplicationEmails_creditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly createAsAdmin: boolean | null, readonly lastLoginAt: any | null };

export type GetApplicationEmails_creditApplication_CreditApplication_admin_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly createAsAdmin: boolean | null, readonly lastLoginAt: any | null };

export type GetApplicationEmails_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly invitedUsersEmails: ReadonlyArray<string | null> | null, readonly collaborators: ReadonlyArray<GetApplicationEmails_creditApplication_CreditApplication_collaborators_CreditApplicationPerson | null> | null, readonly authorizedSigner: GetApplicationEmails_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson | null, readonly beneficialOwners: ReadonlyArray<GetApplicationEmails_creditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson | null> | null, readonly outsourcedAccountant: GetApplicationEmails_creditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson | null, readonly admin: GetApplicationEmails_creditApplication_CreditApplication_admin_CreditApplicationPerson | null };

export type GetApplicationEmails_Query = { readonly __typename: 'Query', readonly creditApplication: GetApplicationEmails_creditApplication_CreditApplication | null };


export type GetApplicationEmailsVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetApplicationEmails = GetApplicationEmails_Query;


export const GetApplicationEmailsDocument = gql`
    query GetApplicationEmails($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    fetchedAt
    invitedUsersEmails
    collaborators {
      ...collaboratorFragment
    }
    authorizedSigner {
      ...collaboratorFragment
    }
    beneficialOwners {
      ...collaboratorFragment
    }
    outsourcedAccountant {
      ...collaboratorFragment
    }
    admin {
      ...collaboratorFragment
    }
  }
}
    ${collaboratorFragment}`;

/**
 * __useGetApplicationEmails__
 *
 * To run a query within a React component, call `useGetApplicationEmails` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationEmails` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationEmails({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetApplicationEmails(baseOptions: Apollo.QueryHookOptions<GetApplicationEmails, GetApplicationEmailsVariables> & ({ variables: GetApplicationEmailsVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationEmails, GetApplicationEmailsVariables>(GetApplicationEmailsDocument, options);
      }
export function useGetApplicationEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationEmails, GetApplicationEmailsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationEmails, GetApplicationEmailsVariables>(GetApplicationEmailsDocument, options);
        }
export function useGetApplicationEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationEmails, GetApplicationEmailsVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApplicationEmails, GetApplicationEmailsVariables>(GetApplicationEmailsDocument, options);
        }
export type GetApplicationEmailsHookResult = ReturnType<typeof useGetApplicationEmails>;
export type GetApplicationEmailsLazyQueryHookResult = ReturnType<typeof useGetApplicationEmailsLazyQuery>;
export type GetApplicationEmailsSuspenseQueryHookResult = ReturnType<typeof useGetApplicationEmailsSuspenseQuery>;
export type GetApplicationEmailsQueryResult = Apollo.QueryResult<GetApplicationEmails, GetApplicationEmailsVariables>;